import { Breadcrumb, MyFirmListItem } from "@/lib/types";
import { isLoggedIn } from "@/sideEffects/persist/authSideEffects";
import { getFirm } from "@/sideEffects/persist/firmSideEffects";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface State {
  isLoggedIn: boolean;
  token?: string;
  activeFirm?: MyFirmListItem;
  breadcrumbs: Breadcrumb[];
  selectedFolderGuid?: string;
}

const initialState: State = {
  isLoggedIn: isLoggedIn(),
  activeFirm: getFirm() ?? undefined,
  breadcrumbs: [],
  selectedFolderGuid: undefined,
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    successfulLogin(state, action: PayloadAction<{ token: string }>) {
      state.isLoggedIn = true;
      state.token = action.payload.token;
    },
    triggerLogout(state) {
      state.isLoggedIn = false;
    },
    setActiveFirm(state, action: PayloadAction<MyFirmListItem>) {
      state.activeFirm = action.payload;
    },
    setBreadcrumbs(state, action: PayloadAction<Breadcrumb[]>) {
      state.breadcrumbs = action.payload;
    },
    setSelectedFolderGuid(state, action: PayloadAction<string>) {
      state.selectedFolderGuid = action.payload;
    },
  },
});

export const appReducer = appSlice.reducer;
export const appActions = appSlice.actions;
